export const RASPADINHA_PRIZE_PASSWORD_MIN_EXCLUSIVE_LENGTH = 8

export function isRaspadinhaPrizePasswordValid(password: string): boolean {
  return password.length > RASPADINHA_PRIZE_PASSWORD_MIN_EXCLUSIVE_LENGTH
}

export function getRaspadinhaPrizePasswordRuleMessage(): string {
  return 'A senha deve ter mais de 8 caracteres.'
}
